import React from 'react';
import Helmet from 'react-helmet';
import { useTranslate } from '../contexts/languageContext';
import Header from '../containers/Header';
import Descarga from '../components/svg/Descarga';
import { NotificationButton } from '../components/NotificationButton';
import { Layout, MidLayout, CajaIzq, CajaDch } from '../containers/Layout';
import { useIsDesktop } from '../hooks/useMediaQuery';
import TabsEleccion from '../containers/TabsEleccion';
import ConsolidadoStats from '../containers/ConsolidadoStats';
import RankingStats from '../containers/RankingStats';
import CheckboxList from '../components/CheckboxList/index';
import FooterLayout from '../components/Footer/Footer';
import { SkipNavLink, SkipNavContent } from '../components/SkipNav';
import { usePage } from '../contexts/pageContext';
import styled from 'styled-components/macro';
import { usePrintEvent } from '../print/Print';
import { responsive } from '../resources/constantes.json';
import DropdownSelectorPropiedades from '../containers/DropdownSelectorPropiedades';
import DropdownSelectorEleccion from '../containers/DropdownSelectorEleccion';
/**
 * Página que muestra estadísticas para cada elección
 */

const Estadisticas = props => {
  const t = useTranslate();
  const isDesktop = useIsDesktop();
  const pageState = usePage();
  const { data, urlInfo } = pageState;
  const {
    page,
    elec,
    tipoEst,
    tipoDato,
    setElec,
    setTipoEst,
    setTipoDato,
  } = urlInfo;
  const title = tipo => {
    let titulo;
    switch (tipo) {
      case 'VV':
        titulo = t('votos') + ' ' + t('validos').toLowerCase();
        break;
      case 'VN':
        titulo = t('votos') + ' ' + t('nulos').toLowerCase();
        break;
      case 'VB':
        titulo = t('votos') + ' ' + t('enBlanco').toLowerCase();
        break;
      case 'NM':
        titulo = t('tarjNoMarc');
        break;
      case 'AB':
        titulo = t('abstencion');
        break;
      case 'VP':
        titulo = t('votacionXPart');
        break;
      case 'PA':
      case 'VT':
        titulo = t('participacion');
        break;
        throw new Error();
    }
    return titulo;
  };
  const consts = {
    titulo: t('tipoEstadistica'),
    color: '#283f5f',
    lista: [
      {
        titulo: t('ranking'),
        tipo: 'R',
        lista: [
          { tipo: 'PA', nombre: title('PA') },
          { tipo: 'VV', nombre: title('VV') },
          { tipo: 'VB', nombre: title('VB') },
          { tipo: 'VN', nombre: title('VN') },
          { tipo: 'NM', nombre: title('NM') },
          { tipo: 'AB', nombre: title('AB') },
          { tipo: 'VP', nombre: title('VP') },
        ],
      },
      {
        titulo: t('consolidado'),
        tipo: 'C',
        lista: [
          { tipo: 'VT', nombre: title('VT') },
          { tipo: 'VV', nombre: title('VV') },
          { tipo: 'VB', nombre: title('VB') },
          { tipo: 'VN', nombre: title('VN') },
          { tipo: 'NM', nombre: title('NM') },
          { tipo: 'AB', nombre: title('AB') },
        ],
      },
    ],
  };

  const vars = {
    vars: [tipoEst, tipoDato],
    funs: [
      params => {
        setTipoEst(params);
      },
      params => {
        setTipoDato(params);
      },
    ],
  };
  return (
    <Layout>
      <SkipNavLink />
      <Helmet>
        <title itemProp="name" lang="es">
          {t('estadisticas')}
        </title>
      </Helmet>
      <Header
        variant="estadisticas"
        page={page}
        nomenclator={props.nomenclator}
      >
        <ContainerHeader>
          <p>{t(page)}</p>
          <TextoColombia>{'Colombia'}</TextoColombia>
        </ContainerHeader>
      </Header>
      <SkipNavContent />
      <CintilloEstadisticas
        tipoDato={tipoDato}
        tipoEst={tipoEst}
        t={t}
        title={title}
        nomenclator={props.nomenclator}
        setElec={setElec}
        eleccion={elec}
      />
      <ContainerGradiente>
        <LayoutEstadistica isDesktop={isDesktop}>
          <CajaIzq as="section" t={t} isDesktop={isDesktop} width="70%">
            {data &&
              (tipoEst === 'C' ? (
                <>
                  <ConsolidadoStats
                    isDesktop={isDesktop}
                    tipo={tipoDato}
                    title={title(tipoDato)}
                    data={data}
                  />
                </>
              ) : (
                <>
                  <ContainerTabla>
                    <RankingStats
                      tipo={tipoDato}
                      title={title(tipoDato)}
                      elec={elec}
                      data={data}
                      nomenclator={props.nomenclator}
                    />
                  </ContainerTabla>
                </>
              ))}
          </CajaIzq>
          {isDesktop ? (
            <CajaDch width="30%" page={page} tipoEst={tipoEst}>
              <CheckboxList atts={consts} vars={vars} elec={elec} />
            </CajaDch>
          ) : (
            <DropdownSelectorPropiedades atts={consts} vars={vars} elec={elec} />
          )}
        </LayoutEstadistica>
        {data && (<FooterContainer>
          <FooterLayout estadisticas />
        </FooterContainer>)}
      </ContainerGradiente>
    </Layout>
  );
};

const CintilloEstadisticas = ({
  tipoEst,
  tipoDato,
  t,
  title,
  nomenclator,
  setElec,
  eleccion,
}) => {
  const printEvent = usePrintEvent();
  const textoInicial = tipoEst === 'C' ? 'consolidado' : 'ranking';
  const isDesktop = useIsDesktop();
  const elecciones = nomenclator.ordAmbitos;
  const filterElectionChange = selectedElection => {
    setElec(selectedElection.elec);
  };
  return (
    <ContainerCintilloSuperior>
      <ContainerCintillo>
        <Title>
          {t(textoInicial)} <TitleStrong>{title(tipoDato)}</TitleStrong>
        </Title>
        <ContainerIconos>
          {isDesktop && (
            <SCajaDescargas>
              <StyledA
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => printEvent()}
              >
                <Descarga width={30} height={30} fill="#1C4183" />
                <div className="visually-hidden">{t('descargarEnPdf')}</div>
              </StyledA>
            </SCajaDescargas>
          )}
          <SCajaNotificacion>
            <NotificationButton nomenclator={nomenclator} />
          </SCajaNotificacion>
        </ContainerIconos>
      </ContainerCintillo>
      {/** Innecesario para presidenciales colombia 2022
      <NombresElecciones>
        {elecciones &&
          (isDesktop ? (
            elecciones.map((elec, i) => {
              return (
                <ButtonEstadistica
                  selected={elec == eleccion}
                  key={i}
                  onClick={() => setElec(elec)}
                  disabled={tipoDato === 'VP' && elec === "7"}
                >
                  {nomenclator.nomAmbitos[elec].n}
                </ButtonEstadistica>
              );
            })
          ) : (
            <DropdownSelectorEleccion
              tipoDato={tipoDato}
              elecciones={elecciones}
              nomenclator={nomenclator}
              selectedEleccion={eleccion}
              onChageElection={filterElectionChange}
            />
          ))}
      </NombresElecciones>
          */}
    </ContainerCintilloSuperior>
  );
};

const FooterContainer = styled.div`
  width:90%;
  margin 0 auto;
  @media (max-width: ${responsive.mobile}px) {
    text-align:center;
    margin-bottom: 50px;
  }
`

const ButtonEstadistica = styled(({ selected, ...rest }) => (
  <button {...rest} />
))`
  color: white;
  color: ${({ selected }) => (selected ? '#00F7F0' : '#fff')};
  background: transparent;
  margin: 3px;
  :hover {
    text-decoration: underline;
  }
  &:disabled {
    color: #4f76b1;
  }
`;
const NombresElecciones = styled.div`
  display: flex;
  justify-content: space-around;
  color: #fff;
`;

const ContainerCintilloSuperior = styled.div`
  width: 100%;
  height: 100%;
  //max-width: 1366px;
  margin: 0 auto;
  background:#1C283D;
`;

const ContainerGradiente = styled.div`
  @media (max-width: ${responsive.mobile}px) {
    background: #fff;
  }
`;

const ContainerIconos = styled.div`
  display: flex;
`;

const SCajaNotificacion = styled(({ push, ...rest }) => <div {...rest} />)`
  flex: 0 0 44px;
  height: 44px;
  background-color: transparent;
  align-self: baseline;
  margin-left: ${({ push }) => (push ? 'auto' : undefined)};
  button {
    background-color: transparent;
  }
  /*necesario poner width y height para el elemento svg para IE11*/
  svg {
    width: 44px;
    height: 44px;
    fill: #1c4183;
  }
  @media (max-width: ${responsive.mobile}px) { {
    flex: 0 0 50px;
    height: 50px;
    /*necesario poner width y height para el elemento svg para IE11*/
    svg {
      width: 50px;
      height: 50px;
      fill: #1c4183;
    }
  }
  @media (min-width: 769px) and (max-width: 1024px) {
    svg {
      fill: #fff;
    }
  }
`;

const SCajaDescargas = styled.div`
  flex: 0 0 auto;
  width: 44px;
  height: 44px;

  align-self: center;
  @media print {
    display: none;
  }
`;

const StyledA = styled.button`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: transparent;
  &&.focus-visible {
    outline: 2px solid #222222 !important;
    outline-offset: -2px !important;
  }
`;

const ContainerCintillo = styled.div`
  display: flex;
  width: 95%;
  height: 100%;
  //max-width: 1366px;
  margin: auto;
  border-top: 1px solid #00f7f0;
  justify-content: space-between;
  align-items: center;
  @media (max-width: ${responsive.tablet}px) {
    margin-top: 60px;
  }
`;

const ContainerTabla = styled.div`
  margin-top: 6px;
  background-color: white;
  max-height: 650px;
  overflow: auto;
  border: 5px solid white;

  @media (max-width: ${responsive.tablet}px) { {
    max-height: unset;
    overflow: unset;

    @media (max-width: ${responsive.mobile}px) { {
      padding-top: 12px;
    }
  }

`;

const TextoEstadisticas = styled.div`
  margin-top: 44px;
  @media (max-width: ${responsive.mobile}px) { {
    margin-top: 0px;
  }
`;

const TextoColombia = styled.p`
  padding-top: 20px;
  font-size: 15px;
  font-weight: 500;
  @media (max-width: 1025px) {
    display: none;
  }
`;
const LayoutEstadistica = styled.div`
  display: flex;
  flex-direction: ${({ isDesktop }) => (isDesktop ? 'row' : 'column')};
  width: 100%;
  height: 100%;
  //max-width: 1366px;
  margin: auto;
`;

const ContenedorTextoColombia = styled.p`
  padding: 5px;
  font-weight: 700;
  background: rgb(240, 240, 240);
  display: none;
  width: 100%;
  padding-left: 1rem;
  font-size: 14px;
  @media (max-width: 1025px) {
    display: block;
  }
`;

const ContainerHeader = styled.div`
  margin-top: 44px;
  @media (max-width: 1025px) {
    margin-top: 0px;
  }
`;

const Title = styled.h3`
  text-transform: capitalize;
  font-style: normal;
  font-size: 22px;
  line-height: 22px;
  color: #fff;
  font-weight: 300;
  padding-left: 10px;
`;

const TitleStrong = styled.span`
  font-weight: bold;
  text-transform: capitalize;
  font-style: normal;
  font-size: 22px;
  line-height: 22px;
  color: #fff;
`;

export default Estadisticas;
